import { Href } from 'expo-router';
import { atom } from 'jotai';

export type FlowReturnRouteKey = 'believeApplication';

export const flowReturnRoutesAtom = atom<
  Partial<Record<FlowReturnRouteKey, Href>>
>({});
